const repositoryList = (state) => {
  return state.repositories.data;
};

export default {
  repositoryList,
};
